module.exports = __webpack_public_path__ + "img/photo-long-3.f4e38da9.jpg";